import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      HEADER: "Bekreft bestillingen",
      CHOSEN_DISHES: "Valgte retter",
      CHANGE_DISHES_LINK_TEXT: "Bytt retter",
      BASKET_VALIDATION_FAILED:
        "Det oppstod en feil under validering av bestillingen. Vennligst prøv igjen.",
      SUM: "Totalt",
      standalone: {
        HEADER: "Dagligvarer",
        LINK_TEXT: "Endre dagligvarer",
      },
      receipt: {
        HEADER: "Bekreft bestillingen",
        SUB_HEADER: "Detaljert oversikt",
        ACCEPT_TERMS_LINK_PREFIX: "Ved å godta aksepterer jeg",
        ACCEPT_TERMS_LINK: "/vilkar",
        ACCEPT_TERMS_LINK_TEXT: "leveransevilkår",
        TOTAL: "Totalt",
      },
      NOTIFICATION_DELIVERY_STARTED: "Dine leveranser er gjenopptatt",
      RESTART_DELIVERY_INFO_TEXT:
        "Dine leveranser er satt på pause. Du kan gjenoppta leveransene ved å trykke på knappen under.",
      RESTART_DELIVERY_BUTTON: "Gjenoppta leveranse",
      ACCEPT_BUTTON: "Bekreft",
      BACK: "Tilbake",
      HAVE_A_NICE_MEAL: "Vel bekomme!",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan ikke bestille før startuke",
    },

    se: {
      HEADER: "Bekräfta beställningen",
      CHOSEN_DISHES: "Utvalda rätter",
      CHANGE_DISHES_LINK_TEXT: "Byt rätter",
      BASKET_VALIDATION_FAILED:
        "Ett fel uppstod när din beställning skulle valideras. Var god försök igen.",
      SUM: "Totalt",
      standalone: {
        HEADER: "Livsmedel",
        LINK_TEXT: "Byt livsmedel",
      },
      receipt: {
        HEADER: "Bekräfta beställningen",
        SUB_HEADER: "Detaljerad översikt",
        ACCEPT_TERMS_LINK_PREFIX: "Genom att godkänna accepterar jag",
        ACCEPT_TERMS_LINK: "Jag godkänner",
        ACCEPT_TERMS_LINK_TEXT: "leveransvillkor",
        TOTAL: "Total",
      },
      NOTIFICATION_DELIVERY_STARTED: "Du har nu leveranser varje vecka!",
      RESTART_DELIVERY_INFO_TEXT:
        "Dina fasta leveranser påbörjas efter att du har bekräftat. Du kan göra ändringar för enskilda leveranser via kalendern.",
      RESTART_DELIVERY_BUTTON: "Starta leveranser",
      ACCEPT_BUTTON: "Bekräfta",
      BACK: "Tillbaka",
      HAVE_A_NICE_MEAL: "Smaklig måltid!",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan inte beställa innan startvecka",
    },

    dk: {
      HEADER: "Bekræft ordre",
      CHOSEN_DISHES: "Valgte retter",
      CHANGE_DISHES_LINK_TEXT: "Skift retter",
      BASKET_VALIDATION_FAILED:
        "Der skete en fejl under valideringen af din ordre. Prøv igen.",
      SUM: "I alt",
      standalone: {
        HEADER: "Specialvarer",
        LINK_TEXT: "Skift specialvarer",
      },
      receipt: {
        HEADER: "Bekræft ordre",
        SUB_HEADER: "Detaljeret oversigt",
        ACCEPT_TERMS_LINK_PREFIX: "Ved at godkende accepterer jeg",
        ACCEPT_TERMS_LINK_TEXT: "leveringsbetingelserne",
        ACCEPT_TERMS_LINK: "/",
        TOTAL: "I alt",
      },
      NOTIFICATION_DELIVERY_STARTED: "Dine leveringer er startet",
      RESTART_DELIVERY_INFO_TEXT:
        "Dine tilbagevendende leveringer vil starter efter du har bekræftet din ordre. Du kan ændre kommende leveringer via leveringskalenderen.",
      RESTART_DELIVERY_BUTTON: "Start leveringer",
      ACCEPT_BUTTON: "Godkend",
      BACK: "Tilbage",
      HAVE_A_NICE_MEAL: "Velbekomme!",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan ikke bestille før startuge",
    },
  } as const
)[language];
